<template slot-scope="scope">
  <!-- 推广详情弹窗 -->

      <dialogModel
        title="推广详情"
        :visible="VisibleCheck"
        :footer="false"
        @handleClose="handleCloseCheck"
      >
        <div class="main-body">
          <img :src="PromotionRow.mediaPath" alt="" v-if="PromotionRow.mediaType == 0" style="margin-bottom:50px"/>
          <video
            :src="PromotionRow.mediaPath"
            controls
            width="400px"
            height="auto"
            :poster="PromotionRow.mediaPath"
            preload="metadata"
            v-if="PromotionRow.mediaType == 1"
            style="margin:0 auto;margin-bottom:50px"
          ></video>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    VisibleCheck: {},
    PromotionRow: {},
  },
  components: {},
  data() {
    return {};
  },
  watch: {
    // VisiblePwd: {
    //   handler(newSs, old) {
    //     if (newSs == false) {
    //       this.ruleForm = { pwd: "" };
    //       setTimeout(() => {
    //         this.$refs.ruleForm.clearValidate();
    //       }, 500);
    //     }
    //   },
    //   immediate: false,
    // },
  },
  computed: {},
  created() {},
  methods: {
    handleCloseCheck() {
      this.$emit("handleCloseCheck");
    },
  },
};
</script>

<style scoped lang="less">
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.main-body {
  width: 450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
</style>
